import { ApiServiceV1 } from '@services/api.service';

export default {
  async getSettings({ suffix }) {
    const { data } = await ApiServiceV1.get(`${suffix}/settings`);
    return data || [];
  },
  updateSettings({ suffix, data }) {
    return ApiServiceV1.post(`${suffix}/settings`, data);
  },
};
